<script>
  import { onMount } from 'svelte';
  import TitleCard from '../assets/general/titlecard.svelte';
  import TitleAndText from '../assets/general/titleandtext.svelte';
  import Title from '../assets/general/title.svelte';
  import Button from '../routes/button.svelte';
  import Img from '../assets/general/ImageLightBox.svelte';
  import HorizontalLine from '../assets/general/HorizontalLine.svelte';
  import Video from '../assets/home/video.svelte';
</script>

<main>
	<TitleCard
	header="Outreach"
	backgroundImage="BunniWestmoPhoto.jpg"
	/>
	<Title
		text="Life-Changing Events"
	/>
	<div class="container">
	<p>There’s nothing more rewarding than coordinating an inspirational event for your organization. The speakers are professional and emotionally impactful; the audience feels engaged and empowered; and, most importantly, the people you care about leave with a buzz of positive energy that will influence their work and attitudes for months, even years, to come.<br><br><strong>Freedom Writer Outreach Events aren’t just presentations. They’re life-changing experiences.</strong><br><br>You’ve read the book. You’ve watched the movie. <em>Now, bring the Freedom Writers’ stories to life!</em></p>
</div>
	<HorizontalLine
	/>
<div class="image-text-container">
		<div class="text-wrapper">
		<h2>Speaking Engagements</h2>
		<br>
		<p>The Freedom Writers provide powerful presentations for students, educators, staff, administrators, and other professionals around the world. Tailored to your organization’s specific needs, their stories act as catalysts for improving:<br><br><ul><li>Classroom attendance</li><li>Student and employee engagement</li><li>Academic and professional performance</li><li>Inclusive and collaborative atmosphere</li></ul><br><br>
		</div>
		<div class="image-container">
		<Img
			imageUrl="../images/other/Narada.jpg"
			imageWidth="150px"
			imageHeight="150px"
			title="Narada Presents"
			altText="Original Freedom Writer Narada on stage presenting."
		/>
		<Img
			imageUrl="../images/other/SueEllen.jpg"
			imageWidth="150px"
			imageHeight="150px"
			title="Original Freedom Writer Sue Ellen Speech"
			altText="Original Freedom Writer Sue Ellen conducts a Freedom Writers Foundation speech at a Keynote Speaking engagement"
		/>
		<Img
			imageUrl="../images/other/TyeAndSueEllen.png"
			imageWidth="150px"
			imageHeight="150px"
			title="Tye and Sue Ellen working with students Freedom Writers Intervention"
			altText="Two of the Original 150 Freedom Writers Tye and Sue Ellen working with students Freedom Writers Youth Engagement Program recreating Room 203."
		/>
		</div>
	</div>
			<div class="button-container">
		<Button
			text="REQUEST A FREEDOM WRITER"
			link="mailto:joshua@freedomwritersfoundation.org"
		/>
	</div>
		<div class="video-container">
		<Video
			videoSRC="https://www.youtube.com/embed/B-aj3GnQPbo?si=7YG_w9xMSqSpbype"
		/>
	</div>
	<HorizontalLine
	/>
<div class="image-text-container">
		<div class="text-wrapper">
		<h2>Video Chats</h2>
		<br>
		<p>Video chats are a cost-effective way to bring Erin and the Freedom Writers into your classroom, community, or professional environment. Invite Ms. G or a Freedom Writer to speak to your group, answer your questions, and share stories. Speakers can cover a variety of topics, from:<br><br><ul><li>Overcoming adversity</li><li>Power of storytelling to heal</li><li>Mental illness and addiction</li><li>Suicide awareness and prevention</li><li>Creating cultures of acceptance, compassion, and integrity</li></ul><br><br>
		</div>
		<div class="image-container">
		<Img
			imageUrl="../images/other/CalvinIIIVC.jpg"
			imageWidth="150px"
			imageHeight="150px"
			title="Calvin Williams III gives a video chat"
			altText="Original Freedom Writer Calvin Williams III gives a video chat."
		/>
		<Img
			imageUrl="../images/other/FW-VC.jpg"
			imageWidth="150px"
			imageHeight="150px"
			title="Freedom Writer Will chatting with class"
			altText="One of the Original 150 Freedom Writers hosts an enthralling video chat about his life and journey, with a class full of enthused students on his chat screen."
		/>
		<Img
			imageUrl="../images/other/EG-VC.jpg"
			imageWidth="150px"
			imageHeight="150px"
			title="Erin Gruwell Video Chat"
			altText="The Founder of the Freedom Writers Foundation, Erin Gruwell, enthusiastically hosting an educational group video chat."
		/>
		</div>
	</div>
			<div class="button-container">
		<Button
			text="BOOK A VIDEO CHAT"
			link="mailto:joshua@freedomwritersfoundation.org"
		/>
	</div>
		<div class="video-container">
		<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/267845734?h=bb5aa7f654" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
	</div>
<HorizontalLine
	/>
<div class="image-text-container">
		<div class="text-wrapper">
		<h2>Documentary Screenings</h2>
		<br>
		<p>Erin Gruwell and the Freedom Writers visit communities all across the country to present their documentary, <em>Freedom Writers: Stories from the Heart</em>, which premiered nationally on PBS in September 2019. The film is gritty, emotional, and provokes meaningful dialogue about race, gender, class, and other social issues. It also sheds a light on the power of storytelling to promote equality and peace.<br><br>With an audience Q&A, a book signing, and meaningful networking opportunities, a Freedom Writer documentary screening is more than entertaining. It’s empowering.</p><br><br>
		</div>
		<div class="image-container">
		<Img
			imageUrl="../images/other/DocPoster-FINAL.jpg"
			imageWidth="auto"
			imageHeight="500px"
			title="Freedom Writers: Stories from the Heart movie poster"
			altText="Movie poster for the Emmy award winning PBS documentary, Freedom Writers: Stories from the Heart."
		/>
		</div>
	</div>
			<div class="button-container">
		<Button
			text="BOOK A SCREENING"
			link="mailto:joshua@freedomwritersfoundation.org"
		/>
	</div>
		<div class="video-container">
		<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/254563532?h=4ee438d013" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
	</div>
</main>

<style>
ul {
	padding-left: 3.4rem;
	line-height: 1.7rem;
	font-size: 1rem;
	font-family: 'Oswald';
}
h2 {
	font-family: 'Oswald';
	padding: 7px 0 7px 0;
}
.image-text-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0 7% 0 7%;
}

.text-wrapper {
	padding: 3.4rem;
    flex: 1; /* Takes as much width as available */
    min-width: 50%; /* Ensures the text takes at least 50% of the container width */
}
p {
    font-size: 1rem;
    font-family: 'Arial';
    line-height: 1.5;
}
.image-container {
	padding: 2rem 0 2rem 0;
	margin-top: 7rem;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    gap: 7px;
    justify-content: center;
    align-items: center;
}
.button-container {
	margin: 25px 0 25px 0;
	text-align: center;
}
.video-container {
	margin: 0 7% 25px 7%;
}
.container {
	margin: 1.7% 7% 1.7% 7%;
	padding: 0 7% 0 7%;
}
@media (max-width: 768px) {
    .image-text-container {
        flex-direction: column; /* Stack items vertically on small screens */
    }

    .image-container {
        margin-top: 0; /* Remove the margin-top for the image-container on small screens */
    }

    .text-wrapper, .image-container {
        padding: 0.5rem;
    }
}
</style>